package org.zq.astrock_ai.ui.research.gushi.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import org.zq.astrock_ai.ui.research.gushi.StockColors
import org.zq.astrock_ai.ui.research.gushi.adaptiveDialogWidth
import org.zq.astrock_ai.ui.research.gushi.model.HoldingPosition
import org.zq.astrock_ai.ui.research.gushi.model.StockItem
import org.zq.astrock_ai.util.formatDecimal

@Composable
fun HoldingAlertDialog(
    stock: StockItem,
    holding: HoldingPosition?,
    onDismiss: () -> Unit,
    onConfirm: (alertPrice: Double?, alertPnlPct: Double?) -> Unit,
    onClear: (() -> Unit)? = null,
) {
    var priceText by remember(holding) {
        mutableStateOf(holding?.alertPrice?.let { formatDecimal(it) }.orEmpty())
    }
    var pnlText by remember(holding) {
        mutableStateOf(holding?.alertPnlPct?.let { formatDecimal(it) }.orEmpty())
    }
    var error by remember { mutableStateOf<String?>(null) }

    val fieldColors = OutlinedTextFieldDefaults.colors(
        focusedTextColor = StockColors.TextPrimary,
        unfocusedTextColor = StockColors.TextPrimary,
        focusedBorderColor = StockColors.PrimaryBlue,
        unfocusedBorderColor = StockColors.Border,
        cursorColor = StockColors.PrimaryBlue,
        focusedLabelColor = StockColors.TextSecondary,
        unfocusedLabelColor = StockColors.TextSecondary,
        focusedContainerColor = Color.White,
        unfocusedContainerColor = Color.White,
    )
    val shape = RoundedCornerShape(14.dp)

    Dialog(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .adaptiveDialogWidth(360.dp)
                .background(Color.White, shape)
                .border(BorderStroke(1.dp, StockColors.Border), shape)
                .padding(20.dp),
        ) {
            Text(
                "持仓提醒 · ${stock.name}",
                color = StockColors.TextPrimary,
                fontWeight = FontWeight.Bold,
                fontSize = 17.sp,
            )
            Spacer(Modifier.height(6.dp))
            Text(
                "需先添加持仓。现价触及提醒价，或浮盈亏达到阈值时提醒。",
                color = StockColors.TextSecondary,
                fontSize = 12.sp,
            )
            Spacer(Modifier.height(14.dp))
            OutlinedTextField(
                value = priceText,
                onValueChange = { priceText = it; error = null },
                label = { Text("提醒价格（可选）") },
                singleLine = true,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                colors = fieldColors,
                modifier = Modifier.fillMaxWidth(),
            )
            Spacer(Modifier.height(10.dp))
            OutlinedTextField(
                value = pnlText,
                onValueChange = { pnlText = it; error = null },
                label = { Text("盈亏%阈值（如 -5 或 8）") },
                singleLine = true,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                colors = fieldColors,
                modifier = Modifier.fillMaxWidth(),
            )
            if (error != null) {
                Spacer(Modifier.height(8.dp))
                Text(error!!, color = StockColors.UpRed, fontSize = 12.sp)
            }
            Spacer(Modifier.height(16.dp))
            Row {
                OutlinedButton(onClick = onDismiss, modifier = Modifier.weight(1f)) {
                    Text("取消")
                }
                Spacer(Modifier.width(8.dp))
                if (onClear != null) {
                    OutlinedButton(onClick = onClear, modifier = Modifier.weight(1f)) {
                        Text("清除")
                    }
                    Spacer(Modifier.width(8.dp))
                }
                Button(
                    onClick = {
                        if (holding == null) {
                            error = "请先添加持仓"
                            return@Button
                        }
                        val price = priceText.trim().takeIf { it.isNotEmpty() }?.toDoubleOrNull()
                        val pnl = pnlText.trim().takeIf { it.isNotEmpty() }?.toDoubleOrNull()
                        if (priceText.isNotBlank() && price == null) {
                            error = "提醒价格无效"
                            return@Button
                        }
                        if (pnlText.isNotBlank() && pnl == null) {
                            error = "盈亏阈值无效"
                            return@Button
                        }
                        if (price == null && pnl == null) {
                            error = "请至少填写一项"
                            return@Button
                        }
                        onConfirm(price, pnl)
                    },
                    modifier = Modifier.weight(1f),
                    colors = ButtonDefaults.buttonColors(containerColor = StockColors.PrimaryBlue),
                ) {
                    Text("保存")
                }
            }
        }
    }
}
